document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.footer-block__heading').forEach((menu) => {
    menu.addEventListener('click', (event) => {
      if (!menu.closest('details').hasAttribute('open')) {
        document.querySelectorAll('.footer-block--menu').forEach((m) => m.removeAttribute('open'));
      }
    });
  });
});
